import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/system';
import { ReactNode } from 'react';
import { ScanAlertMessages, ScanAlerts } from './ScanAlerts';

const styles = {
  content: {
    '& .MuiAlert-root': {
      my: 0,
    },
    background: (theme: Theme) => theme.palette.qrScanner.background,
    bottom: 0,
    position: 'absolute',
    px: 2,
    py: 1,
    top: 0,
    width: 'calc(100% - 222px)',
  },
  root: {
    height: '180px',
    mb: 1,
    mt: 2,
    position: 'relative',
  },
  title: {
    '& h6': {
      fontSize: 'medium',
      pb: 0.5,
    },
    color: 'white',
    pb: 2,
  },
} as const;

interface IQRScanDesktopLayoutProps {
  title: ReactNode;
  description: ReactNode;
  scanAlertsMessages: ScanAlertMessages;
  error: string;
  children: ReactNode;
}

export function QRScanDesktopLayout({
  children,
  description,
  error,
  scanAlertsMessages,
  title,
}: IQRScanDesktopLayoutProps) {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.content}>
        <Grid container sx={{ flexDirection: 'column', height: '100%' }}>
          <Grid>
            <Box sx={styles.title}>
              <Typography variant="h6">{title}</Typography>
              <Typography variant="body2">{description}</Typography>
            </Box>
          </Grid>
          <Grid sx={{ mt: 'auto' }}>
            <ScanAlerts error={error} messages={scanAlertsMessages} />
          </Grid>
        </Grid>
      </Box>
      {children}
    </Box>
  );
}
